@let badgesVal = safeBadges();
@let minimizedVal = minimized();

@if (minimizedVal) {
  <div cdkOverlayOrigin #badgesOrigin></div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayOrigin]="badgesOrigin"
    [cdkConnectedOverlayOpen]="visible()"
    [cdkConnectedOverlayPositionStrategy]="positionStrategy"
  >
    <div>
      @for (badge of badgesVal; track 'label') {
        <rt-badge [color]="badge.color" [text]="badge.text" />
      }
    </div>
  </ng-template>
} @else {
  @for (badge of badgesVal; track 'label') {
    <rt-badge [color]="badge.color" [text]="badge.text" />
  }
}
